// extracted by mini-css-extract-plugin
export default {"names":"ListItemImgMultiInfo_names__VziMa","images":"ListItemImgMultiInfo_images__XBBIz"};